<script setup lang="ts">
import { useSocket } from '@/hooks/useSocket';
import { useAuthStore } from '@/stores/auth/auth.slice';
import type { Socket } from 'socket.io-client';
import { computed, onUnmounted, watch } from 'vue';
import { RouterView, useRouter } from 'vue-router';
import ActionErrorToast from '../components/ActionErrorToast.vue';
import NoticeToast from '../components/NoticeToast.vue';
import ReadyConfirmModal from '../components/ReadyConfirmModal.vue';
import ReadyToast from '../components/ReadyToast.vue';
import { usesFakeData } from '../mode';
import { usePdsOrdersStore } from '../stores/orders.store';

const CLOCK_TICK_MS = 15_000;

const authStore = useAuthStore();
const store = usePdsOrdersStore();
const router = useRouter();

store.load();

if (!usesFakeData()) {
  const { socketOrders } = useSocket();
  watch(
    socketOrders,
    (socket, _previous, onCleanup) => {
      if (socket) onCleanup(store.bindSocket(socket as Socket));
    },
    { immediate: true },
  );
}
const clock = setInterval(store.tick, CLOCK_TICK_MS);
onUnmounted(() => {
  clearInterval(clock);
  store.stopTimers();
});

watch(
  () => authStore.connectStatus,
  (status) => {
    if (status === 'disconnected') router.push('/login');
  },
);

const readyOrder = computed(
  () => store.readyRequestId && store.byId(store.readyRequestId),
);
</script>

<template>
  <div
    class="font-pds bg-papier text-encre flex h-[100dvh] w-full flex-col overflow-hidden"
  >
    <RouterView />
    <ReadyConfirmModal v-if="readyOrder" :order="readyOrder" />
    <ReadyToast />
    <ActionErrorToast />
    <NoticeToast />
  </div>
</template>
